<template lang="pug">
  .business-documents.custom-container
    .section-title Documentos
    b-breadcrumb.breadcrumb(:items="breadcrumbs")
    .table-view
      ListBusiness
</template>

<script>
import ListBusiness from '../components/business_documents/ListBusiness'
export default {
  data(){
    return{
      breadcrumbs: [
        {
          text: 'Inicio',
          to: { name: 'Home' }
        },
        {
          text: 'Documentos',
          active:true
        },
      ]
    }
  },
  components: {
    ListBusiness
  }
}
</script>
